<!-- 详情页组件 -->
<template>
  <detail-page v-page-loading="loading">
    <left-detail ref="LeftDetail" slot="left" :showData="formData" />
    <detail-right-view
      slot="right"
      allPodSwitch
      allBaseSwitch
      abnormalTask
      copyBtn
      showNetInfo
      showPackInfo
      showNetLast
      showStepBar
      :waybillNo="waybillNo"
      :tabs="tabls"
      :prescriptionData="prescriptionData"
      :active="active"
    >
      <!-- 语音质检 -->
      <div slot="ccQuality" class="historical-conversation">
        <iframe ref="iframe" class="iframe" :src="iframeUrl" />
      </div>
    </detail-right-view>
  </detail-page>
</template>

<script>
import { publicApi } from './pool'
import LeftDetail from './LeftDetail.vue'

const tablsBase = ['imQuality', 'handleQt', 'CustomerServiceOrder', 'workOrder', 'trail', 'base', 'problem', 'arbitration', 'CallRecords', 'postalOrder', 'PhoneCallLog', 'MessageBoard']

export default {
  name: 'PublicView',
  data() {
    return {
      loading: false,
      formData: null, // 详情数据
      waybillNo: null, // 运单号
      tabls: [],
      iframeUrl: '',
      active: '',
      prescriptionData: {}
    }
  },
  components: {
    LeftDetail
  },
  watch: {
    '$route.params.id': {
      handler(newVal, oldVal) {
        if (newVal && oldVal && newVal !== oldVal) {
          this.getDetail()
        }
      },
      deep: true
    }
  },
  created() {
    this.getDetail()
  },
  methods: {
    // 获取详情
    async getDetail() {
      const { id } = this.$route.params
      if (!id) return
      const { data = {}} = await publicApi.reqDetail(id)
      this.formData = data
      const { sessionWaybillNos = [], taskSource = '', taskBizId = '' } = data
      this.waybillNo = sessionWaybillNos[0] || ''
      const firstTab = {
        CC: 'ccQuality',
        IM: 'imQuality',
        WO: 'woQuality'
      }
      const baseArr = [...tablsBase]
      baseArr[0] = firstTab[taskSource]
      this.tabls = [...baseArr]
      this.active = this.tabls[0]
      if (taskSource === 'CC') {
        this.getCcUrl(taskBizId)
      }
      this.getPrescriptData()
      // 刷新质检记录
      this.$bus.$emit('handleListRefresh')
    },
    // 语音质检url
    getCcUrl(checkNo) {
      const timestamp = new Date().getTime()
      // let url = 'https://uat-psae.jtexpress.com.cn'
      // let userToken = 'dc081cac-b629-43b6-b7d3-6636677e28e9'
      // if (location.hostname === 'jms.jtexpress.com.cn') {
      //   url = 'https://psae.jtexpress.com.cn'
      //   userToken = 'fc9cf227-fbcd-4303-87c4-e41348060f3a'
      // }
      // 生产
      const url = 'https://psae.jtexpress.com.cn'
      const userToken = 'fc9cf227-fbcd-4303-87c4-e41348060f3a'
      this.iframeUrl = `${url}/taskView?id=${checkNo}&timestamp=${timestamp}&userToken=${userToken}`
    },
    // 查询当前物流轨迹
    async getPrescriptData() {
      if (!this.waybillNo) return
      const { data } = await publicApi.getSecondType({ waybillNo: this.waybillNo, id: '' })
      this.prescriptionData = data
    }
  }
}
</script>

<style lang="scss" scoped>
.historical-conversation {
  height: calc(100vh - 175px);
  border: 1px solid #cccccc;
  .iframe {
    width: 100%;
    height: 100%;
    border: 0;
  }
}
::v-deep .right-view{
  width: 50%;
}
::v-deep .left-wrap {
  overflow-y: auto;
}
</style>
